import React from 'react';
import LocalStorageService from '../Services/LocalStorage/LocalStorageService';

export type LocalStorageContextProps = {
    localStorageService: LocalStorageService,
};

const LocalStorageContext: React.Context<LocalStorageContextProps> = React.createContext<LocalStorageContextProps>({
    localStorageService: new LocalStorageService('vesselManager'),
});

export default LocalStorageContext;